import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ErrorOutline } from '@mui/icons-material';
import TextRenderer from './TextRenderer';
import TableRenderer from './TableRenderer';
import ChartRenderer from './ChartRenderer';
import StatCardRenderer from './StatCardRenderer';
import spacing from '../../design-system/spacing';

const ErrorBlock = ({ message }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        p: 1.5,
        borderRadius: `${spacing.borderRadius.md}px`,
        backgroundColor: alpha(theme.palette.error.main, theme.palette.mode === 'dark' ? 0.18 : 0.1),
        border: `1px solid ${alpha(theme.palette.error.main, 0.35)}`,
      }}
    >
      <ErrorOutline sx={{ color: theme.palette.error.main, fontSize: 20 }} />
      <Typography variant="body2" sx={{ color: 'text.primary' }}>
        {message || 'Se produjo un error al procesar este contenido.'}
      </Typography>
    </Box>
  );
};

const JsonFallback = ({ data }) => (
  <Box
    sx={{
      p: 1.5,
      borderRadius: `${spacing.borderRadius.md}px`,
      backgroundColor: 'action.hover',
      overflow: 'auto',
      maxHeight: 200,
    }}
  >
    <Typography
      component="pre"
      variant="caption"
      sx={{
        fontFamily: "'Roboto Mono', monospace",
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        m: 0,
        color: 'text.secondary',
      }}
    >
      {JSON.stringify(data, null, 2)}
    </Typography>
  </Box>
);

const ContentBlockRouter = ({ block }) => {
  if (!block) return null;

  switch (block.type) {
    case 'text':
      return <TextRenderer content={block.value || block.content} />;

    case 'table':
      return <TableRenderer data={block.data} />;

    case 'chart':
      return <ChartRenderer data={block.data} />;

    case 'stats':
      return <StatCardRenderer data={block.data} />;

    case 'error':
      return <ErrorBlock message={block.message || block.content} />;

    default:
      return <JsonFallback data={block} />;
  }
};

export default ContentBlockRouter;
